import Layout from '../components/Layout'
import { useTransition } from '../context/TransitionContext'

function Home() {
  const { triggerTransition } = useTransition()

  const handleWorkClick = () => {
    triggerTransition('/work', 'work')
  }

  return (
    <Layout>
      <div className="h-full flex flex-col items-center justify-center text-center px-4 sm:px-8 md:px-16">
        <p className="uppercase font-semibold tracking-wider mb-4 sm:mb-8 text-sm md:text-base">
          WELCOME
        </p>

        <p className="text-2xl sm:text-4xl md:text-5xl font-medium max-w-[30rem] sm:max-w-[30rem] md:max-w-[40rem] lg:max-w-[58rem] mb-4 leading-snug">
          Hey, I'm Niklavs — your new favorite programmer. I turn ideas into
          digital magic. Let's create something unforgettable.
        </p>

        <button
          onClick={handleWorkClick}
          className="mt-4 sm:mt-8 bg-black text-white px-6 sm:px-8 py-4 sm:py-5 rounded-md hover:bg-gray-800 transition-colors font-semibold text-sm sm:text-base"
        >
          Check out my work
        </button>
      </div>
    </Layout>
  )
}

export default Home
